import Image from "next/legacy/image";
import React, { forwardRef, useEffect, useState } from "react";
import { useContext } from "react";
import { isMobileContext } from "../../contexts/isMobileContext";
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { useRouter } from "next/router";
import Amenity from "../common/Amenity";
import AmenityMobile from "../common/AmenityMobile";
import { useInView } from "react-intersection-observer";
import FadeIn from "../Animations/FadeIn";
// eslint-disable-next-line react/display-name
const Amenities = forwardRef(({ phasePage,
	projectPage,
	businessProject,
	servicesHeader,
	services,
	phaseColor,
	commercialServices,
	foodCourt,
	servicesDescription,
	grey
}, ref) => {
	const { isMobile } = useContext(isMobileContext);
	const { locale } = useRouter()
	const [active, setActive] = useState(0)
	let [amenityRef, inView] = useInView({ threshold: 1, triggerOnce: true })
	const [slideNumber, setSlideNumber] = useState(1)
	return (
		<div className={`amenities-section ${phasePage ? 'phasePage' : ''}
		${commercialServices ? "commercialServices-section" : ""}
		${foodCourt ? "food-court" : ""}
		${grey ? "grey-bg" : ""}
		`} ref={ref}

		>
			<div ref={amenityRef}>
				<FadeIn customClass="header">
					<h2 className="light _eleX">{servicesHeader}</h2>
					<p className="light _eleX">{servicesDescription}</p>
				</FadeIn>
			</div>
			{!isMobile ? (
				<div className={`amenities-container ${inView ? "in-view" : ""}`}>
					{services?.map((amenity, index) => (
						<Amenity inView businessProject={businessProject} phaseColor={phaseColor} amenity={amenity} key={index} index={index} projectPage={projectPage} commercialServices={commercialServices} phasePage={phasePage} />
					))}
				</div>
			) : (
				<div className={`amenities-swiper-mobile ${inView ? "in-view" : ""}`}>
					<Swiper
						onSlideChange={(swiper) => { setActive(swiper.activeIndex), setSlideNumber(1 + swiper.activeIndex) }}
						key={services?.length}
						style={{ direction: locale == "ar" ? "rtl" : "ltr" }}
						modules={[Navigation, Pagination]}
						navigation={{
							nextEl: ".swiper-button-next-amenities",
							prevEl: ".swiper-button-prev-amenities",
						}}
						slidesPerView={1}
						spaceBetween={20}
						breakpoints={{
							768: {
								slidesPerView: 1.5,
								spaceBetween: 20,
							},
							1023: {
								slidesPerView: 2.5,
								spaceBetween: 20,
							},
						}}
						pagination={{
							type: "progressbar",
							el: ".swiper-amenate-navigation",
						}}
					>
						{services?.map((amenity, index) => (
							<SwiperSlide key={index}>
								<AmenityMobile active={active} phaseColor={phaseColor} amenity={amenity} commercialServices={commercialServices} businessProject={businessProject} index={index} />
							</SwiperSlide>
						))}
						<div className={`swiper-navigation-continer ${services?.length == 1 ? "d-none" : ""}`}>
							<div className='navigation-container'>
								<div className='slide-number-container bold'>
									<div>{slideNumber.toLocaleString('en-US', { minimumIntegerDigits: 2 })}</div>
									<div>{services?.length.toLocaleString('en-US', { minimumIntegerDigits: 2 })}</div>
								</div>
								<div className='swiper-amenate-navigation swiper-pagination-progressbar'></div>
							</div>
								<div className="arrows-container">
									<div className="swiper-button-prev swiper-button-prev-amenities amenities-arrow black-arrow-prev"></div>
									<div className="swiper-button-next swiper-button-next-amenities  amenities-arrow black-arrow-next"></div>
								</div>
						</div>
					</Swiper>
				</div>
			)}
		</div>
	);
})
export default Amenities